import imageTikki from '../../images/game-tikki.png';
import imagePlag from '../../images/game-plag.png';
import imageBanix from '../../images/game-banix.png';
import imagePollen from '../../images/game-pollen.png';
import imageXuppu from '../../images/game-xuppu.png';

export const APP_GAME_KWAMI = {
    tikki: {
        code: 'tikki',
        image: imageTikki,
        coins: 3,
        freeze: false,
        reset: false,
    },
    plag: {
        code: 'plag',
        image: imagePlag,
        coins: 2,
        freeze: false,
        reset: false,
    },
    banix: {
        code: 'banix',
        image: imageBanix,
        coins: 5,
        freeze: false,
        reset: false,
    },
    pollen: {
        code: 'pollen',
        image: imagePollen,
        coins: 0,
        freeze: true,
        reset: false,
    },
    xuppu: {
        code: 'xuppu',
        image: imageXuppu,
        coins: 0,
        freeze: false,
        reset: true,
    }
};